import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { multipleStepsMethods } from "domains/postGig/constants";
import { queries as postGigMultipleStepsQueries } from "domains/postGig/containers/PostGigMultipleSteps/queries";
import { queries as postSingleGigQueries } from "domains/postGig/containers/PostSingleGig/queries";
import { queries as copySourceQueries } from "domains/postGig/hooks/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; search: MarketplaceSearch };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  ...copySourceQueries(input),
  ...(multipleStepsMethods.includes(input.search.post_gig_type ?? "single")
    ? postGigMultipleStepsQueries(input)
    : postSingleGigQueries(input)),
];
